const $ = jQuery;

const data = {
    category: null,
    sorting: null,
    s: '',
    paged: 1,
};

const postsContainer = document.querySelector('.js-guarantee--posts-container');
const searchInput = document.querySelector('.js-guarantee-archive-search input');
const loadMoreBtn = document.querySelector('.js-load-more .c-button--download');

export default function newsGuarantee() {
    getSearch();
    restartData();
    loadMore();
}

function loadMore() {
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
            event.preventDefault();
            data.paged++;
            getPosts(true);
        });
    }
}

function getCurrentPostIds() {
    let posts = postsContainer.querySelectorAll('.card-post');
    let ids = [];
    posts.forEach(post => {
        let id = post.dataset.postId;
        if (id) {
            ids.push(id);
        }
    });
    return ids;
}

function getSearch() {
    let timer;
    if (searchInput) {
        searchInput.addEventListener('keyup', function() {
            const value = searchInput.value;
            clearTimeout(timer);
            if (value.length > 2 || value.length === 0) {
                timer = setTimeout(function() {
                    data.s = value;
                    data.paged = 1;
                    getPosts();
                }, 500);
            }
        });
    }
}


function restartData() {
    const resetDataTrigger = document.querySelector('.js-reset-filters');
    const categories = document.querySelectorAll('.js-news-archive-categories li');

    if (resetDataTrigger) {
        resetDataTrigger.addEventListener('click', function() {
            data.category = null;
            data.sorting = null;
            data.s = '';
            data.paged = 1;

            if (searchInput) {
                searchInput.value = '';
            }

            categories.forEach(cat => cat.classList.remove('active'));
            categories.forEach(opt => opt.classList.remove('active'));

            const firstCategory = document.querySelector('.js-news-archive-categories li:first-child');
            const firstSorting = document.querySelector('.js-news-archive-sorting li:first-child');

            if (firstCategory) {
                firstCategory.classList.add('active');
                data.category = firstCategory.getAttribute('data-term-id');
            }

            if (firstSorting) {
                firstSorting.classList.add('active');
                data.sorting = firstSorting.getAttribute('data-sorting');
            }
            getPosts();
        });
    }
}

/**
 * Get posts
 */
function getPosts(loadMore = false) {
    let ajaxData = {
        action: 'getAjaxGuarantees',
        data: {
            paged: data.paged,
            post_id: postsContainer.dataset.postId
        }
    };

    if (data.category) ajaxData.data.category = data.category;
    if (data.sorting) ajaxData.data.sorting = data.sorting;
    if (data.s) ajaxData.data.s = data.s;

    $.ajax({
        url: menaObject.ajaxurl,
        type: 'GET',
        data: ajaxData,
        dataType: 'json',
        beforeSend() {
            postsContainer.classList.add('loading');
        },
        success(response) {
            if (!response) {
                return;
            }

            if (response.status === 'success') {
                const postsHtml = response.html.join('');
                if (loadMore) {
                    $('.js-guarantee--posts-container').append(postsHtml);
                } else {
                    postsContainer.innerHTML = postsHtml;
                }

                if (response.loadMore === false) {
                    $('.js-load-more').hide();
                } else {
                    $('.js-load-more').show();
                }
            } else if (response.status === 'no_result') {
                if (!loadMore) {
                    postsContainer.innerHTML = response.html;
                }
                $('.js-load-more').hide();
            } else {
                // Ako je status nešto drugo, tretiramo ga kao grešku
                if (!loadMore) {
                    postsContainer.innerHTML = response.html;
                }
                $('.js-load-more').hide();
            }

            postsContainer.classList.remove('loading');
        },
        error(error) {
            postsContainer.classList.remove('loading');
        },
    });
}

document.addEventListener('click', function(e) {
    if (e.target.closest('.js-archive--reset')) {
        e.preventDefault();
        data.category = null;
        data.sorting = null;
        data.s = '';
        data.paged = 1;
        
        if (searchInput) searchInput.value = '';
        const categories = document.querySelectorAll('.js-news-archive-categories li');
        categories.forEach(cat => cat.classList.remove('active'));
        const firstCategory = document.querySelector('.js-news-archive-categories li:first-child');
        if (firstCategory) {
            firstCategory.classList.add('active');
            data.category = firstCategory.getAttribute('data-term-id');
        }
        const sortings = document.querySelectorAll('.js-news-archive-sorting li');
        sortings.forEach(opt => opt.classList.remove('active'));
        const firstSorting = document.querySelector('.js-news-archive-sorting li:first-child');
        if (firstSorting) {
            firstSorting.classList.add('active');
            data.sorting = firstSorting.getAttribute('data-sorting');
        }
        getPosts();
    }
});